import AuthenticationService from "service/auth/AuthenticationService";
import EnvironmentService from "service/environment/EnvironmentService";
import APIConfig from "service/network/APIConfig";
import APIService from "service/network/APIService";

class UserService {
  constructor() {
    this.authenticationService = new AuthenticationService();
    this.environmentService = new EnvironmentService();
    this.apiService = new APIService();
  }

  getOTP(cc, phoneNo, tenantId, onResponse, onError) {
    let url =
      APIConfig.user.getOTPNew +
      "?phoneno=" +
      phoneNo +
      "&countrycode=" +
      cc +
      "&tenantid=" +
      tenantId;

    return this.apiService.get(url, onResponse, onError);
  }

  verifyOTP(countrycode, phoneNo, otp, tenantId, onResponse, onError) {
    let url = APIConfig.user.verifyOTPNew;
    let data = {
      countrycode: parseInt(countrycode),
      phoneno: parseInt(phoneNo),
      otp: parseInt(otp),
      tenantid: parseInt(tenantId),
    };

    return this.apiService.post(url, data, onResponse, onError);
  }
  getDoctorOTP(phoneNo, onResponse, onError) {
    let url = APIConfig.user.getDoctorOTP + "?phoneno=" + phoneNo;

    return this.apiService.get(url, onResponse, onError);
  }

  verifyDoctorOTP(phoneNo, otp, onResponse, onError) {
    let url = APIConfig.user.verifyDoctorOTP;
    let data = {
      phoneno: parseInt(phoneNo),
      otp: parseInt(otp),
    };

    return this.apiService.post(url, data, onResponse, onError);
  }

  // MFA — second step (after SMS OTP) for any non-patient role.
  // partialToken comes from the previous verify response when mfaStatus
  // was EMAIL_OTP_REQUIRED. otp is the 6-digit code from the email.
  verifyEmailOtp(partialToken, otp, onResponse, onError) {
    let url = APIConfig.user.verifyEmailOtp;
    let data = {
      partialToken: partialToken,
      otp: parseInt(otp),
    };
    return this.apiService.post(url, data, onResponse, onError);
  }

  new(employee, onResponse, onError) {
    let url = APIConfig.user.new;

    return this.apiService.post(url, employee, onResponse, onError);
  }

  getAll(onResponse, onError) {
    let url = APIConfig.user.getAll;

    return this.apiService.get(url, onResponse, onError);
  }

  getEmployeeInfo(employeeId, onResponse, onError) {
    let url = APIConfig.user.get.format(employeeId);

    return this.apiService.get(url, onResponse, onError);
  }

  /**
   * Did this user sign in through the DOCTOR login (/doctor/login), rather than
   * the employee one?
   *
   * Renamed from `isDoctor()`. The body is unchanged — only the name, which was
   * describing the wrong thing. It does not ask what KIND of clinician someone
   * is: a nutritionist signing in through /doctor/login answers true here, and
   * a doctor who also holds an employeeProfile answers false. What it actually
   * identifies is the LOGIN ROUTE, and that is what its 13 call sites want —
   * ten of them are `readOnly:` gates that make the old patient screens
   * view-only for anyone who came in that way.
   *
   * DO NOT swap this for a category test. `doctorProfile.category === 1` is a
   * different question and would break these gates both ways: a nutritionist on
   * /doctor/login would gain write access to all ten screens, and a care
   * manager who also holds a category-1 doctorProfile would lose it.
   *
   * phr's UserService has an `isDoctor()` that DOES mean category 1 — it gates
   * the Create Rx button there. The two apps ask different questions of the
   * same profile; this one is deliberately not named `isDoctor` any more so
   * they cannot be confused. phr's login never reaches /doclogin at all, which
   * is why the equivalent there was always false and had to change.
   */
  isDoctorLogin() {
    let isDoc = false;
    const user = this.authenticationService.getUserProfile();
    if (
      user &&
      user.doctorProfile &&
      user.doctorProfile.id > 0 &&
      !user.employeeProfile
    ) {
      isDoc = true;
    }
    return isDoc;
  }
  isEmployee() {
    let isEmp = false;
    const user = this.authenticationService.getUserProfile();
    if (user && user.employeeProfile && user.employeeProfile.id > 0) {
      isEmp = true;
    }
    return isEmp;
  }
  searchDoctorCode(code, onSuccess, onError) {
    const url = APIConfig.user.verifyDocCode.format(code);
    this.apiService.get(url, onSuccess, onError);
  }
}

export default UserService;
